// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import { useContext } from "react";

import { LoadingContext } from "./LoadingContext";

export const useLoading = () => useContext(LoadingContext);
